/* eslint-disable vue/match-component-file-name */

import {VueComponent} from '@tfx/common/initializers'

import flashMessage from './components/flash-message'

import Multiselect from 'vue-multiselect'

import {Tabs, Tab} from './components/vue-tabs-component/index'

VueComponent('flash-message', flashMessage)
VueComponent('multiselect', Multiselect)

// Global:
VueComponent('sentry-logger', () => import('./components/sentry-logger'))
VueComponent('documents-upload', () => import('./components/documents/documents-upload'))
VueComponent('modal-dialog', () => import('./components/modal-dialog'))
VueComponent('icon-close', () => import('./components/icons/icon-close'))
VueComponent('icon-search', () => import('./components/icons/icon-search'))
VueComponent('errors-dialog', () => import('./components/errors-dialog'))
VueComponent('messages', () => import('./components/messages'))
VueComponent('bill-clarification-messages', () => import('./components/bill-clarification-messages'))
VueComponent('accordion', () => import('./components/accordion'))
VueComponent('accordion-pure', () => import('./components/accordion-pure'))
VueComponent('date-picker', () => import('./components/date-picker'))
VueComponent('confirmation-button', () => import('./components/confirmation-button'))
VueComponent('tfx-multiselect', () => import('./components/forms/tfx-multiselect'))
VueComponent('tfx-country-selector', () => import('./components/forms/country-selector/country-selector'))
VueComponent('tfx-us-state-selector', () => import('./components/forms/us-state-selector/us-state-selector'))
VueComponent('user-info-dropdown', () => import('./components/user-info-dropdown'))
VueComponent('help-button', () => import('./components/notifications/help-button'))
VueComponent('help-button-mobile', () => import('./components/notifications/help-button-mobile'))
VueComponent('notifications-button', () => import('./components/notifications/notifications-button'))
VueComponent('comments-list', () => import('./components/comments/comments-list'))
VueComponent('attach-documents-modal', () => import('./components/comments/client_attachments/attach-documents-modal'))
VueComponent('attach-email-modal', () => import('./components/comments/client_attachments/attach-email-modal'))
VueComponent('attach-questions-modal', () => import('./components/comments/client_attachments/attach-questions-modal'))
VueComponent('client-logout-button', () => import('./components/logout/client-logout-button'))
VueComponent('tfx-dropdown', () => import('./components/tfx-dropdown'))
VueComponent('help-panel', () => import('@tfx/client/components/help-panel'))
VueComponent('video-guide', () => import('@/tq/components/video-guide/video-guide'))

VueComponent('field-with-counter', () => import('./components/FieldWithCounter'))

// Admin area
VueComponent('fileupload-small', () => import('./components/fileupload-small'))
VueComponent('document-previewer-dialog', () => import('./components/document-previewer-dialog'))
VueComponent('tab', Tab)
VueComponent('tabs', Tabs)

// trix-toolbar and trix-editor should load synchronously so that the toolbar is already
// loaded by the time the editor is initialized. Related issue: https://tfxtax.atlassian.net/browse/TFX-6741
//
VueComponent('tfx-trix-toolbar', () => import(/* webpackChunkName: "tfx-trix" */'@tfx/common/components/tfx-trix-toolbar'))
VueComponent('tfx-trix-editor', () => import(/* webpackChunkName: "tfx-trix" */'@tfx/common/components/tfx-trix-editor'))

VueComponent('tfx-drawer', () => import('tfx-common/components/tfx-drawer'))
VueComponent('tfx-button', () => import('tfx-common/components/tfx-button'))
